export const ROUTES = {
  BUSINESS: {
    LANDING: {
      path: '/business',
      title: 'Waka Business',
      requiresAuth: false,
    },
    DEMO: {
      path: '/business/demo',
      title: 'Waka Business Demo',
      requiresAuth: true,
    },
  },
  AUTH: {
    SIGNUP: {
      path: '/auth/signup',
      title: '회원가입',
      requiresAuth: false,
    },
    SIGNIN: {
      path: '/auth/signin',
      title: '로그인',
      requiresAuth: false,
    },
    B2B_SIGNIN: {
      path: '/auth/enterprise-signin',
      title: 'Enterprise 로그인',
      requiresAuth: false,
    },
    B2B_SIGNUP: {
      path: '/auth/enterprise-signup',
      title: 'Enterprise 회원가입',
      requiresAuth: false,
    },
    HELP_PW: {
      path: '/auth/help/pw',
      title: '비밀번호 찾기',
      requiresAuth: false,
    },
    SOCIAL_SIGNUP: {
      path: '/auth/social-signup',
      title: '소셜 회원가입',
      requiresAuth: false,
    },
  },
} as const;

/** `/business` 랜딩 → 로그인·회원가입 완료 후 Wakaverse `/demo` 에 해당하는 `/business/demo` 로 이동 (`returnUrl`) */
export const BUSINESS_SIGNIN_HREF_WITH_DEMO_RETURN = `${ROUTES.AUTH.SIGNIN.path}?returnUrl=${encodeURIComponent(ROUTES.BUSINESS.DEMO.path)}`;
